import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import dayjs from 'dayjs';
import {
  ApplyLoan,
  ConfirmApplicationBody,
  CustomDimensions,
  DeeplinkBody,
  EventGATagging,
} from '../../interfaces/js-interface.interface';

export interface JavascriptCallback {
  openAppDeeplink(data: string): any;
  enterFullScreen(data: string): any;
  exitFullScreen(data: any): any;
  confirmApplication(data: string): any;
  gaTagging(data: any): any;
  applyLoan(data: any): any;
}

declare const LoanWeb: JavascriptCallback;
declare const window: any;
declare const webkit: any;
@Injectable({
  providedIn: 'root',
})
export class JsInterfaceService {
  constructor(private router: Router) {}

  public enterFullScreen(url?: string) {
    const urlCombine = `${environment.baseUrl}${url}`;
    console.log('enterFullScreen: ', urlCombine);
    const body = JSON.stringify({
      redirectUrl: urlCombine,
    });
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf('android') > -1;
    try {
      if (isAndroid) {
        const android = LoanWeb;
        console.log('isAndroid');
        android.enterFullScreen(body);
      } else {
        window.webkit.messageHandlers.enterFullScreen.postMessage(body);
      }
    } catch (error) {
      console.log('isWeb');
    } finally {
      this.router.navigate([url], {
        skipLocationChange: false,
      });
    }
  }

  public openDeepLink(data?: DeeplinkBody) {
    console.log('openDeepLink', data);
    const body = JSON.stringify(data);
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf('android') > -1;

    try {
      if (isAndroid) {
        let android = LoanWeb;
        console.log('isAndroid');
        android.openAppDeeplink(body);
      } else {
        window.webkit.messageHandlers.openAppDeeplink.postMessage(body);
      }
    } catch (error) {
      console.log('isWeb');
    }
  }

  public exitFullScreen(previousUrl?: string) {
    console.log('exitFullScreen');
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf('android') > -1;
    try {
      if (isAndroid) {
        let android = LoanWeb;
        console.log('isAndroid');
        android.exitFullScreen(null);
      } else {
        window.webkit.messageHandlers.exitFullScreen.postMessage(null);
      }
    } catch (error) {
      console.log('isWeb');
    } finally {
      if (previousUrl) this.router.navigate([previousUrl]);
    }
  }

  public confirmApplication(data: ConfirmApplicationBody) {
    const body = JSON.stringify(data);
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf('android') > -1;
    try {
      if (isAndroid) {
        let android = LoanWeb;
        console.log('isAndroid');
        android.confirmApplication(body);
      } else {
        window.webkit.messageHandlers.confirmApplication.postMessage(body);
      }
    } catch (error) {
      console.log('isWeb');
      // handle when open on web
    }
  }

  public gaTagging(
    event: EventGATagging,
    customDimensions?: CustomDimensions[]
  ) {
    const data = customDimensions
      ? {
          event,
          customDimensions,
        }
      : { event };

    console.log(data, 'gaTagging');

    const body = JSON.stringify(data);
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf('android') > -1;
    try {
      if (isAndroid) {
        let android = LoanWeb;
        console.log('isAndroid');
        android.gaTagging(body);
      } else {
        window.webkit.messageHandlers.gaTagging.postMessage(body);
      }
    } catch (error) {
      console.log('isWeb');
      // handle when open on web
    }
  }

  public applyLoan(data?: ApplyLoan) {
    console.log('applyLoan', data);
    const body = JSON.stringify(data);
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf('android') > -1;

    try {
      if (isAndroid) {
        let android = LoanWeb;
        console.log('isAndroid');
        android.applyLoan(body);
      } else {
        window.webkit.messageHandlers.applyLoan.postMessage(body);
      }
    } catch (error) {
      console.log('isWeb');
    }
  }

  public generateApplicationRef(systemRef: string, campaignID: string) {
    const year = dayjs().format('YY');
    const month = dayjs().format('MM');
    const date = dayjs().format('DD');
    const randomNumber = Math.floor(100000 + Math.random() * 900000);
    return `${systemRef}${campaignID}${year}${month}${date}${randomNumber}`;
  }
}
